
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, limit, milkType, shopFixCostCategory} from "../../../comman/config";
import Loader from "../../../comman/Loader";
import { PencilIcon, XCircleIcon } from '@heroicons/react/outline';
import {DateFilter} from "../../../comman/DateFilter.js";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";
import * as XLSX from 'xlsx';


function List() {

    const [fixCostList, setFixCostList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [name, setName] = useState('');
    
    const user_id = localStorage.getItem("userId");

    const navigate = useNavigate();

    useEffect(() => {
        getFixCost();
        
    }, [page, fromDate,toDate, name]);


    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }

    const getFixCost = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/shop_fix_cost/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}&user_id=${user_id}`);
        setPopupOpen(false);
        setFixCostList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const deleteFixCost = async (id) => {
        try {
            await axios.delete(`${baseUrl}/shop_fix_cost/delete/${id}`);
            window.location.reload();
        } catch (error) {
            console.log(error);
        }

    };

   const getProuctName = (item) => {
        if(item.product_type == 1){
            return milkType.find((val) => val.value == item.milk_type)?.label ?? "-"
        }else{
            return item.product_name;
        }

   }

    const editFixCost = async (id) => {
        navigate(`/shop_fix_cost/edit/${btoa(id)}`, { state: fixCostList.filter(item => item.id == id) });
    }

    const handelFilterChange= (fromDate, toDate, clear, today, name) => {
        setFromDate(fromDate);
        setToDate(toDate); 
        setName(name); 
    };

    const getCategoryName = (id) => {
        return shopFixCostCategory.find((item) => item.value == id).label;
    }
    const getCostAmount = (item) => {
        if(item.category == 1){
            return item.rent_amount;
        }else if(item.category == 2 || item.category == 5){
            return item.bill_amount;
        }else if(item.category == 3){
            return item.material_amount;
        }else if(item.category == 4){
            return item.petrol_cost;
        }else if(item.category == 6){
            return item.other_amount;
        }
    }

    const exportToExcel = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/shop_fix_cost/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}&user_id=${user_id}&type=true`);
        setPopupOpen(false);
    
        const data = response.data.data;
    
        const exportData = data.map(item => ({
            Date: item.date,
            Shop_Name: item.shop_name,
            Category: getCategoryName(item.category),
            Cost: getCostAmount(item)
        }));
    
        // Calculate total cost
        const totalCost = exportData.reduce((sum, item) => sum + (parseFloat(item.Cost) || 0), 0);
    
        // Add total row at the end
        exportData.push({},{
            Date: '',
            Shop_Name: '',
            Category: 'Total',
            Cost: totalCost
        });
    
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "FixCostList");
    
        XLSX.writeFile(workbook, "Fix_Cost_List.xlsx");
    };


    return (
        
        <div className="p-4">
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Fix Cost List</h1>
                <div>
                <button
    onClick={exportToExcel}
    className="px-4 py-2 bg-green-700 text-white rounded-md mr-2 hover:bg-green-500 focus:outline-none focus:ring focus:ring-green-200"
>
    Export to Excel
</button>
                    <Link to="/shop_fix_cost/add">
                        <button className="px-4 py-2 bg-blue-900 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Cost</button>
                    </Link>
                </div>
            </div>
            
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <DateFilter 
                handleFilterChange={handelFilterChange} 
            />
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                        <th scope="col" className="px-6 py-3 border">Date</th>
                        <th scope="col" className="px-6 py-3 border">Shop Name</th>
                        <th scope="col" className="px-6 py-3 border">Category</th>
                        <th scope="col" className="px-6 py-3 border">Cost</th>
                        <th scope="col" className="px-6 py-3 border">Action</th>
                        </tr>
                       
                    </thead>
                    <tbody>
                    {fixCostList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                            <td className="px-6 py-4">{item.shop_name}</td>
                            <td className="px-6 py-4">{getCategoryName(item.category)}</td>
                            <td className="px-6 py-4">{getCostAmount(item)}</td>
                           
                            <td className="px-6 py-4 flex">
                                    <a 
                                    onClick={() => editFixCost(item.id)}
                                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline mr-2">
                                        <PencilIcon className="w-4 h-4 inline-block" /> {/* Edit icon */}
                                    </a>
                                    <a href="#" onClick={() => deleteFixCost(item.id)} className="font-medium text-red-600 dark:text-red-500 hover:underline">
                                        <XCircleIcon className="w-4 h-4 inline-block" /> 
                                    </a>
                                </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
            {totalItem > limit && (<Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalItem}
              pageRangeDisplayed={5}
              onChange={handlePageChange.bind(this)}
            />)}
        </div>
  );
}

export default List;